module.exports = __webpack_public_path__ + "static/img/index_swper_08.db8bf5af.png";